import React, { Component } from 'react';
import KpiCard from './shared/KpiCard';
import { formatNum } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';
import { PAYPAL_PAYOUTS_ENABLED } from '../../config/constants';

var Auth = new AuthService();

class AdminSellerBalances extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellers: [],
      total: 0,
      page: 1,
      pages: 1,
      totals: { held: 0, released: 0, disputed: 0, refunded: 0 },
      loading: true,
      search: '',
      sort: 'held_desc',
      selectedIds: [],
      batchLoading: false,
    };
    this.fetchBalances = this.fetchBalances.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleToggleSelect = this.handleToggleSelect.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleBatchRelease = this.handleBatchRelease.bind(this);
    this.searchTimeout = null;
  }

  componentDidMount() {
    this.fetchBalances();
  }

  fetchBalances(page) {
    var self = this;
    self.setState({ loading: true });
    var p = page || self.state.page;
    var params = new URLSearchParams();
    params.append('page', p);
    params.append('limit', 20);
    params.append('sort', self.state.sort);
    if (self.state.search) params.append('search', self.state.search);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/payments/seller-balances?' + params.toString())
      .then(function(data) {
        self.setState({
          sellers: data.sellers || [],
          total: data.total || 0,
          page: data.page || 1,
          pages: data.pages || 1,
          totals: data.totals || { held: 0, released: 0, disputed: 0, refunded: 0 },
          loading: false,
          selectedIds: [],
        });
      })
      .catch(function(err) {
        console.log('Failed to fetch seller balances:', err);
        self.setState({ loading: false });
      });
  }

  handleSearch(e) {
    var self = this;
    var val = e.target.value;
    self.setState({ search: val });
    clearTimeout(self.searchTimeout);
    self.searchTimeout = setTimeout(function() {
      self.setState({ page: 1 }, function() { self.fetchBalances(1); });
    }, 400);
  }

  handleSort(e) {
    var self = this;
    self.setState({ sort: e.target.value, page: 1 }, function() { self.fetchBalances(1); });
  }

  handleToggleSelect(sellerId) {
    var self = this;
    var idx = self.state.selectedIds.indexOf(sellerId);
    var updated = self.state.selectedIds.slice();
    if (idx === -1) {
      updated.push(sellerId);
    } else {
      updated.splice(idx, 1);
    }
    self.setState({ selectedIds: updated });
  }

  handleSelectAll() {
    var self = this;
    var heldSellers = self.state.sellers.filter(function(s) { return s.held > 0; });
    if (self.state.selectedIds.length === heldSellers.length && heldSellers.length > 0) {
      self.setState({ selectedIds: [] });
    } else {
      self.setState({ selectedIds: heldSellers.map(function(s) { return s._id; }) });
    }
  }

  handleBatchRelease() {
    var self = this;
    if (self.state.selectedIds.length === 0) return;

    var selectedSellers = self.state.sellers.filter(function(s) {
      return self.state.selectedIds.indexOf(s._id) !== -1;
    });

    // Collect all held transaction IDs from selected sellers — we need to fetch them
    // Since the batch-release endpoint expects transaction IDs, we pass seller IDs and let backend handle it
    self.props.onConfirm({
      title: 'Batch Release Payouts',
      message: 'Release all held payouts for ' + selectedSellers.length + ' seller' + (selectedSellers.length > 1 ? 's' : '') + '? This will process all held orders for the selected sellers.',
      btnColor: '#10B981',
      btnIcon: 'fa-check',
      onConfirm: function() {
        self.setState({ batchLoading: true });
        return Auth.fetch(constants.DOMAIN + '/api/v1/admin/payments/batch-release', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sellerIds: self.state.selectedIds }),
        })
          .then(function(data) {
            self.setState({ batchLoading: false, selectedIds: [] });
            alert('Released ' + data.released + ' payout(s).' + (data.failed > 0 ? ' ' + data.failed + ' failed.' : ''));
            self.fetchBalances();
          })
          .catch(function(err) {
            self.setState({ batchLoading: false });
            alert('Batch release failed: ' + (err.message || 'Unknown error'));
          });
      }
    });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var sellers = this.state.sellers;
    var totals = this.state.totals;
    var heldSellers = sellers.filter(function(s) { return s.held > 0; });
    var allSelected = heldSellers.length > 0 && self.state.selectedIds.length === heldSellers.length;

    return (
      <div>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
          <div>
            <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Seller Balances</h2>
            <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-0.5">Per-seller financial summary</p>
          </div>
          {self.state.selectedIds.length > 0 && (
            <button
              onClick={this.handleBatchRelease}
              disabled={this.state.batchLoading}
              className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90 disabled:tw-opacity-50"
              style={{ backgroundColor: '#10B981' }}
            >
              <i className="fa fa-check" /> Release Selected ({self.state.selectedIds.length})
            </button>
          )}
        </div>

        {/* Summary Cards */}
        <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4 tw-mb-6">
          <KpiCard icon="fa-lock" label="Total Held" value={'$' + formatNum(totals.held)} color="#3B82F6" />
          <KpiCard icon="fa-check-circle" label="Total Released" value={'$' + formatNum(totals.released)} color="#10B981" />
          <KpiCard icon="fa-exclamation-triangle" label="Total Disputed" value={'$' + formatNum(totals.disputed)} color="#EF4444" />
          <KpiCard icon="fa-undo" label="Total Refunded" value={'$' + formatNum(totals.refunded)} color="#6B7280" />
        </div>

        {/* Filters */}
        <div className="tw-flex tw-flex-wrap tw-gap-3 tw-mb-4">
          <div className="tw-relative tw-flex-1" style={{ minWidth: 200, maxWidth: 320 }}>
            <i className="fa fa-search tw-absolute tw-left-3 tw-text-[#999]" style={{ top: '50%', transform: 'translateY(-50%)' }} />
            <input
              type="text"
              value={this.state.search}
              onChange={this.handleSearch}
              placeholder="Search sellers..."
              className="tw-w-full tw-pl-9 tw-pr-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white"
            />
          </div>
          <select
            value={this.state.sort}
            onChange={this.handleSort}
            className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white"
          >
            <option value="held_desc">Held (High to Low)</option>
            <option value="held_asc">Held (Low to High)</option>
            <option value="released_desc">Released (High to Low)</option>
            <option value="total_desc">Total Orders</option>
          </select>
        </div>

        {this.state.loading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <div className="tw-text-center">
              <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
              <span className="tw-text-sm tw-text-[#999]">Loading...</span>
            </div>
          </div>
        ) : sellers.length === 0 ? (
          <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <i className="fa fa-inbox tw-text-4xl tw-text-[#ccc] tw-mb-3" style={{ display: 'block' }} />
            <p className="tw-text-sm tw-text-[#999] tw-m-0">No sellers found</p>
          </div>
        ) : (
          <div>
            {/* Sellers Table */}
            <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
              <div className="tw-overflow-x-auto">
                <table className="tw-w-full tw-text-sm">
                  <thead>
                    <tr style={{ backgroundColor: isDark ? '#111' : '#fafafa' }}>
                      <th className="tw-px-4 tw-py-2.5 tw-text-center" style={{ width: 40 }}>
                        <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={this.handleSelectAll}
                          className="tw-cursor-pointer"
                        />
                      </th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Seller</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-right tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase">Held</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-right tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden sm:tw-table-cell">Released</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-right tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden md:tw-table-cell">Disputed</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden lg:tw-table-cell">Orders</th>
                      <th className="tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-hidden lg:tw-table-cell">Payment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sellers.map(function(s) {
                      var isSelected = self.state.selectedIds.indexOf(s._id) !== -1;
                      var hasHeld = s.held > 0;
                      var hasStripe = s.seller && s.seller.stripeAccountId;
                      var hasPaypal = s.seller && s.seller.paypalEmail;

                      return (
                        <tr key={s._id} className={'tw-border-t tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#fafafa] dark:hover:tw-bg-[#1e1e1e]' + (isSelected ? ' tw-bg-[#f0fdf4] dark:tw-bg-[#0a2e1a]' : '')}>
                          <td className="tw-px-4 tw-py-3 tw-text-center">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={function() { self.handleToggleSelect(s._id); }}
                              disabled={!hasHeld}
                              className="tw-cursor-pointer disabled:tw-opacity-30"
                            />
                          </td>
                          <td className="tw-px-4 tw-py-3">
                            <div className="tw-flex tw-items-center tw-gap-3">
                              <div
                                className="tw-w-8 tw-h-8 tw-rounded-full tw-bg-[#f0f0f0] dark:tw-bg-[#333] tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-flex-shrink-0"
                              >
                                {s.seller && s.seller.profilePic ? (
                                  <img src={s.seller.profilePic} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                                ) : (
                                  <i className="fa fa-user tw-text-xs tw-text-[#999]" />
                                )}
                              </div>
                              <div>
                                <button
                                  onClick={function() { if (self.props.onOpenUserModal) self.props.onOpenUserModal(s._id); }}
                                  className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-sm tw-cursor-pointer tw-font-semibold hover:tw-underline tw-text-[#1a1a1a] dark:tw-text-white"
                                >
                                  {s.seller ? s.seller.userName : 'Unknown'}
                                </button>
                                {s.seller && s.seller.email && (
                                  <p className="tw-text-xs tw-text-[#999] tw-m-0">{s.seller.email}</p>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-right">
                            {s.held > 0 ? (
                              <span className="tw-font-semibold" style={{ color: '#3B82F6' }}>
                                ${s.held.toFixed(2)}
                                <span className="tw-text-xs tw-text-[#999] tw-ml-1">({s.heldOrders})</span>
                              </span>
                            ) : (
                              <span className="tw-text-[#999]">$0.00</span>
                            )}
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-right tw-hidden sm:tw-table-cell">
                            <span className="tw-font-medium" style={{ color: s.released > 0 ? '#047857' : '#999' }}>
                              ${s.released.toFixed(2)}
                            </span>
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-right tw-hidden md:tw-table-cell">
                            {s.disputed > 0 ? (
                              <span className="tw-font-medium" style={{ color: '#EF4444' }}>${s.disputed.toFixed(2)}</span>
                            ) : (
                              <span className="tw-text-[#999]">$0.00</span>
                            )}
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-center tw-hidden lg:tw-table-cell">
                            <span className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa]">{s.totalOrders}</span>
                          </td>
                          <td className="tw-px-4 tw-py-3 tw-text-center tw-hidden lg:tw-table-cell">
                            <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">
                              {hasStripe && (
                                <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full" style={{ backgroundColor: '#F0F0FF', color: '#635BFF' }}>
                                  <i className="fa fa-cc-stripe" /> Stripe
                                </span>
                              )}
                              {/* PayPal email — hidden when PayPal payouts are disabled */}
                              {PAYPAL_PAYOUTS_ENABLED && hasPaypal && (
                                <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full" style={{ backgroundColor: '#FFF4E6', color: '#003087' }}>
                                  <i className="fa fa-paypal" /> PayPal
                                </span>
                              )}
                              {!hasStripe && !hasPaypal && (
                                <span className="tw-text-xs tw-text-[#999]">None</span>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pagination */}
            {this.state.pages > 1 && (
              <div className="tw-flex tw-items-center tw-justify-between tw-mt-4">
                <span className="tw-text-sm tw-text-[#999]">
                  Page {this.state.page} of {this.state.pages} ({this.state.total} sellers)
                </span>
                <div className="tw-flex tw-gap-2">
                  <button
                    disabled={this.state.page <= 1}
                    onClick={function() { var p = self.state.page - 1; self.setState({ page: p }, function() { self.fetchBalances(p); }); }}
                    className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-sm tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                  >
                    Prev
                  </button>
                  <button
                    disabled={this.state.page >= this.state.pages}
                    onClick={function() { var p = self.state.page + 1; self.setState({ page: p }, function() { self.fetchBalances(p); }); }}
                    className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-sm tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default AdminSellerBalances;
